import { CircularProgress } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getGeneralUseQueries } from "../../Apis/GeneralUseQueryApi";
import GeneralQueryCard from "../../Component/GeneralQueryCard";
import Navbar from "../../Component/Navbar";
import {
    Content,
    Heading,
    LoaderCont,
    MainBody,
    ProductList,
} from "./GeneralUseQueriesPage.styles";

const GeneralUseQueriesPage = () => {
    const { sportType } = useParams();
    const [martItems, setMartItems] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isBgLoading, setIsBgLoading] = useState(false);


    const fetchData = async () => {
        if (isLoading) return;
        setIsLoading(true);
        const data = await getGeneralUseQueries(sportType);
        if (data) {
            setMartItems(data);
        }
        setIsLoading(false);
    };

    const fetchDataBg = async () => {
        if (isBgLoading) return;
        setIsBgLoading(true)
        const data = await getGeneralUseQueries(sportType);
        if (data) {
            setMartItems(data);
        }
        setIsBgLoading(false)
    };

    useEffect(() => {
        fetchData();
        let interval = setInterval(() => {
            fetchDataBg();
        }, 60 * 1000);

        return () => {
            clearInterval(interval);
        };
    }, []);

    return (
        <article>
            <Navbar />

            <MainBody>
                <Content>
                    <Heading>Useful Queries of {sportType}</Heading>
                    {isLoading ? (
                        <LoaderCont>
                            <CircularProgress />
                        </LoaderCont>
                    ) : (
                        <ProductList>
                            {martItems.length > 0 ? (
                                <>
                                    {martItems.map((item) => (
                                        <GeneralQueryCard
                                            data={item}
                                            key={item.id}
                                            fetchData={fetchData}
                                        />
                                    ))}
                                </>
                            ) : (
                                <p>No item to show</p>
                            )}
                        </ProductList>
                    )}
                </Content>
            </MainBody>
        </article>
    );
};

export default GeneralUseQueriesPage;
